import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { UserConsumer } from "../../../UserContext";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { Link, Redirect, useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { Table } from "../../../components/CustomPaginations";
import { dateCol, tableStyle } from "../../../components/TableStyle";
import Header from "../../../components/Header";
import FilterationBar from "./FilterationBar";
import { ReviewLeaveApplication_API } from "./ReviewLeaveApplication_API";
import { AlertPopups } from "../../../components/AlertPopups";
import BulkRowActionButtonsBar from "../../../components/BulkRowActionButtonsBar";
import {
	GlobalPaginationSize,
	getPaginationSizeOnRole,
} from "../../../components/GlobalPaginationSize";
import { APIDateFormat } from "../../Dashboard/DashboardVariables";
import { Routes } from "../../../configurations/config";
import ButtonLoader from "../../../components/ButtonLoader";
import { ExcelBtnClassName, ExcelBtnTitle } from "../../ticketModule/variables/ListingVariables";

function ReviewLeaveApplication() {
	let token,
		empDesignation,
		empRole = null;
	const history = useHistory();

	const defaultSorted = [
		{
			dataField: "appliedDate",
			order: "asc",
		},
	];
	const [pageNum, setPageNum] = useState(1);
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	const [pagerData, setPagerData] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
		GlobalPaginationSize.defaultPaginationSize
	);
	const [apiHeaderToken, setApiHeaderToken] = useState(null);
	const [spReviewLeaveData, setSpReviewLeaveData] = useState([]);
	const [leaveTypes, setLeaveTypes] = useState(null);
	const [supervisorsEmpList, setSupervisorsEmpList] = useState(null);
	const [selectedSupEmp, setSelectedSupEmp] = useState(null);
	const [selectedLeaveType, setSelectedLeaveType] = useState(null);
	const [endDatePickerDisabled, setEndDatePickerDisabled] = useState(true);
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const [checkboxSelected, setCheckboxSelected] = useState(false);
	const [rejectSelectedBtnLoad, setRejectSelectedBtnLoad] = useState(false);
	const [approveSelectedBtnLoad, setApproveSelectedBtnLoad] = useState(false);
	const [selectedRows, setSelectedRows] = useState([]);
	const [disableApproveSelectedbtn, setDisableApproveSelectedBtn] =
		useState(true);
	const [disableRejectSelectedbtn, setDisableRejectSelectedBtn] =
		useState(true);
	const [bulkSelectedData, setBulkSelectedData] = useState([]);
	const [AllColumns, setColumns] = useState(null);

	const getStatusText = (status) => {
		if (status === "Pending") return "Pending";
		else if (status === "InProgress") return "Pending";
		else if (status === "Invalid") return "Invalid";
		else if (status === "Approved") return "Approved";
		else if (status === "Rejected") return "Rejected";
		else return "Pending";
	};
	const getStatusStyle = (status) => {
		if (status === "Pending") return { color: "#ffbe5c" };
		else if (status === "Approved") return { color: "green" };
		else if (status === "Rejected") return { color: "tomato" };
		else return { color: "#ffbe5c" };
	};

	const getColumns = [
		{
			dataField: "employeeName",
			text: "Employee Name",
			sort: true,
		},
		{
			dataField: "appliedDate",
			text: "Applied Date",
			formatter: dateCol,
			sort: true,
		},
		{
			dataField: "leaveType",
			text: "Leave Type",
			sort: true,
		},
		{
			dataField: "startDate",
			text: "Start Date",
			sort: true,
			formatter: dateCol,
		},
		{
			dataField: "endDate",
			text: "End Date",
			sort: true,
			formatter: dateCol,
		},
		{
			dataField: "leaveDuration",
			text: "Leave Duration",
			sort: true,
		},
		{
			dataField: "status",
			text: "Status",
			sort: true,
			formatter: getStatusText,
			style: getStatusStyle,
		},
		{
			dataField: "action",
			text: "Action",
			hidden: true,
			events: {
				onClick: (e) => {
					// To stop navigation to detail screen
					e.stopPropagation();
				},
			},
			formatter: (cell, row) => {
				return (
					<div>
						<Link
							to={{
								pathname: `${Routes.ReviewLeaveApplication}/${row.id}`,
								state: { itemStatus: row.itemStatus },
							}}
						>
							<button className="btnStyle" title="View Detail">
								<FontAwesomeIcon
									id="edit"
									className="hoverEffect"
									icon={faEye}
									size="1x"
								/>
							</button>
						</Link>
					</div>
				);
			},
		},
	];

	useEffect(() => {
		setColumns(getColumns);
		let pageSize = getPaginationSizeOnRole(empDesignation);
		setNumberOfItemsPerPage(pageSize);

		let tokenHeader = {
			Authorization: `Bearer ${token}`,
		};

		if (empRole.includes("3")) {
			//admin
			pageSize = GlobalPaginationSize.AdminPaginationSize;
			setNumberOfItemsPerPage(pageSize);

			axios
				.get(`${ReviewLeaveApplication_API.GetAdminEmployeesList}`, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				.then(({ status, data }) => {
					if (status === 200) {
						const supEmpList = data.map((obj) => {
							return { value: obj.employeeId, label: obj.name };
						});
						let removeAllStatus = supEmpList.filter(
							(item) => item.label != "All"
						);
						let sorted = removeAllStatus.sort((a, b) =>
							a.label.localeCompare(b.label)
						);
						let all = { value: 0, label: "All" };
						sorted.unshift(all);
						setSupervisorsEmpList(sorted);
						setSelectedSupEmp(all);
					}
				});
		} else {
			//get Supervisor Employee List
			axios
				.get(
					`${ReviewLeaveApplication_API.GetSupervisorsEmployeesList}`,
					{
						headers: {
							Authorization: `Bearer ${token}`,
						},
					}
				)
				.then(({ status, data }) => {
					if (status === 200) {
						const supEmpList = data.map((obj) => {
							return { value: obj.employeeId, label: obj.name };
						});
						let removeAllStatus = supEmpList.filter(
							(item) => item.label != "All"
						);
						let sorted = removeAllStatus.sort((a, b) =>
							a.label.localeCompare(b.label)
						);
						let all = { value: 0, label: "All" };
						sorted.unshift(all);
						setSupervisorsEmpList(sorted);
						if (sessionStorage.getItem("ReviewLeaveApplication"))
							if (
								JSON.parse(
									sessionStorage.getItem(
										"ReviewLeaveApplication"
									)
								)[0]
							) {
								setSelectedSupEmp(
									JSON.parse(
										sessionStorage.getItem(
											"ReviewLeaveApplication"
										)
									)[0]
								);
							} else setSelectedSupEmp(all);
						else setSelectedSupEmp(all);
					}
				});
		}

		//get leave Types
		axios
			.get(`${ReviewLeaveApplication_API.GetLeaveTypes}`, {
				headers: tokenHeader,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					const types = data.types;
					types.unshift({ value: 0, label: "All" });

					if (sessionStorage.getItem("ReviewLeaveApplication"))
						if (
							JSON.parse(
								sessionStorage.getItem("ReviewLeaveApplication")
							)[1]
						) {
							setSelectedLeaveType(
								JSON.parse(
									sessionStorage.getItem(
										"ReviewLeaveApplication"
									)
								)[1]
							);
						} else setSelectedLeaveType(types[0]);
					else setSelectedLeaveType(types[0]);

					setLeaveTypes(
						types.sort((a, b) => a.label.localeCompare(b.label))
					);
				}
			});

		//get table data

		getUnreviewedLeaves(pageSize);

		setApiHeaderToken(tokenHeader);
	}, []);



	const getUnreviewedLeaves = (pageSize) => {
		let employeeId = 0;
		let type = 0;
		if (sessionStorage.getItem("ReviewLeaveApplication")) {
			if (JSON.parse(sessionStorage.getItem("ReviewLeaveApplication"))[0])
				employeeId = JSON.parse(
					sessionStorage.getItem("ReviewLeaveApplication")
				)[0].value;

			if (JSON.parse(sessionStorage.getItem("ReviewLeaveApplication"))[1])
				type = JSON.parse(
					sessionStorage.getItem("ReviewLeaveApplication")
				)[1].value;
		}

		axios
			.get(
				`${
					ReviewLeaveApplication_API.GetUnreviewedLeaves_API
				}Type=${type}&EmployeeId=${employeeId}&PageSize=${
					pageSize || numberOfItemsPerPage
				}&PageNumber=${pageNum}&SortBy=${sortBy.dataField}_${
					sortBy.order
				}`,

				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setSpReviewLeaveData(res.data.unreviewedLeaveApplications);
				}
			});
	};
	const onDateFilteration = (StartDate, EndDate) => {
		setIsLoading(true);
		const startDateFormated = moment(StartDate).format(APIDateFormat);
		const endDateFormated = moment(EndDate).format(APIDateFormat);

		axios
			.get(
				`${ReviewLeaveApplication_API.GetUnreviewedLeaves_API}PageSize=${numberOfItemsPerPage}&StartDate=${startDateFormated}&EndDate=${endDateFormated}&SortBy=${sortBy.dataField}_${sortBy.order}&Type=${selectedLeaveType.value}&EmployeeId=${selectedSupEmp.value}`,
				{
					headers: apiHeaderToken,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setSpReviewLeaveData(res.data.unreviewedLeaveApplications);
				}
			})
			.catch((error) => {
				if (error.response) {
					AlertPopups.ErrorAlert.fire({
						text: error.response.data.message,
					});
				}
			});
	};

	const updateTableData = (empId, leaveType) => {
		setIsLoading(true);
		let apiURL = "";
		if (startDate) {
			const startDateFormated = moment(startDate).format(APIDateFormat);
			const endDateFormated = moment(endDate).format(APIDateFormat);
			apiURL = `${ReviewLeaveApplication_API.GetUnreviewedLeaves_API}PageSize=${numberOfItemsPerPage}&EmployeeId=${empId}&Type=${leaveType}&SortBy=${sortBy.dataField}_${sortBy.order}&StartDate=${startDateFormated}&EndDate=${endDateFormated}`;
		} else {
			apiURL = `${ReviewLeaveApplication_API.GetUnreviewedLeaves_API}PageSize=${numberOfItemsPerPage}&EmployeeId=${empId}&Type=${leaveType}&SortBy=${sortBy.dataField}_${sortBy.order}`;
		}
		axios
			.get(apiURL, {
				headers: apiHeaderToken,
			})
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setSpReviewLeaveData(res.data.unreviewedLeaveApplications);
				}
			});
	};
	const exportToExcel = (e) => {
		;
	
		e.preventDefault();
		setIsLoading(true);
		let apiUrl = "";
		if (startDate) {
			const startDateFormated = moment(startDate).format(APIDateFormat);
			const endDateFormated = moment(endDate).format(APIDateFormat);
			apiUrl = `${
				ReviewLeaveApplication_API.ExportToExcel
			}?EmployeeId=${selectedSupEmp.value}&Type=${
				selectedLeaveType.value
			}StartDate=${startDateFormated}&EndDate=${endDateFormated}`;
		} else {
			apiUrl = `${
				ReviewLeaveApplication_API.ExportToExcel
			}?EmployeeId=${selectedSupEmp.value}&Type=${
				selectedLeaveType.value
			}`;
		}
		axios
			.get(apiUrl, {
				headers: apiHeaderToken,
				responseType: "blob",
			})
			.then((response) => {
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute(
					"download",
					"ReviewedLeaveApplication.xlsx"
				);
				document.body.appendChild(link);
				link.click();
				setIsLoading(false);
			})
			.catch(() => {
				setIsLoading(false);
			});
	};


	const receiveData = (PageSize) => {
		setIsLoading(true);
		let apiUrl = "";
		if (startDate) {
			const startDateFormated = moment(startDate).format(APIDateFormat);
			const endDateFormated = moment(endDate).format(APIDateFormat);
			apiUrl = `${
				ReviewLeaveApplication_API.GetUnreviewedLeaves_API
			}PageNumber=${1}&EmployeeId=${selectedSupEmp.value}&Type=${
				selectedLeaveType.value
			}&PageSize=${PageSize}&SortBy=${sortBy.dataField}_${
				sortBy.order
			}&StartDate=${startDateFormated}&EndDate=${endDateFormated}`;
		} else {
			apiUrl = `${
				ReviewLeaveApplication_API.GetUnreviewedLeaves_API
			}PageNumber=${1}&EmployeeId=${selectedSupEmp.value}&Type=${
				selectedLeaveType.value
			}&PageSize=${PageSize}&SortBy=${sortBy.dataField}_${sortBy.order}`;
		}
		axios
			.get(apiUrl, {
				headers: apiHeaderToken,
			})
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setNumberOfItemsPerPage(PageSize);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setSpReviewLeaveData(res.data.unreviewedLeaveApplications);
				}
			});
	};

	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		setIsLoading(true);
		let getData = false;
		let apiURL = "";
		if (startDate) {
			const startDateFormated = moment(startDate).format(APIDateFormat);
			const endDateFormated = moment(endDate).format(APIDateFormat);
			if (type === "sort") {
				apiURL = `${ReviewLeaveApplication_API.GetUnreviewedLeaves_API}EmployeeId=${selectedSupEmp.value}&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&SortBy=${sortField}_${sortOrder}&Type=${selectedLeaveType.value}&StartDate=${startDateFormated}&EndDate=${endDateFormated}`;
				setSortBy({ dataField: sortField, order: sortOrder });
				getData = true;
			} else if (type === "pagination") {
				apiURL = `${ReviewLeaveApplication_API.GetUnreviewedLeaves_API}EmployeeId=${selectedSupEmp.value}&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&SortBy=${sortBy.dataField}_${sortBy.order}&Type=${selectedLeaveType.value}&StartDate=${startDateFormated}&EndDate=${endDateFormated}`;
				getData = true;
			}
		} else {
			if (type === "sort") {
				apiURL = `${ReviewLeaveApplication_API.GetUnreviewedLeaves_API}EmployeeId=${selectedSupEmp.value}&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&SortBy=${sortField}_${sortOrder}&Type=${selectedLeaveType.value}`;
				setSortBy({ dataField: sortField, order: sortOrder });
				getData = true;
			} else if (type === "pagination") {
				apiURL = `${ReviewLeaveApplication_API.GetUnreviewedLeaves_API}EmployeeId=${selectedSupEmp.value}&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&SortBy=${sortBy.dataField}_${sortBy.order}&Type=${selectedLeaveType.value}`;
				getData = true;
			}
		}

		if (getData) {
			axios
				.get(apiURL, {
					headers: apiHeaderToken,
				})
				.then((res) => {
					if (res.status === 200) {
						setIsLoading(false);
						setPageNum(page);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setSpReviewLeaveData(
							res.data.unreviewedLeaveApplications
						);
					}
				});
		}
	};
	const storeFiltersStates = (value, property) => {
		let obj = [];
		if (sessionStorage.getItem("ReviewLeaveApplication"))
			obj = JSON.parse(sessionStorage.getItem("ReviewLeaveApplication"));
		if (property === "emp") obj[0] = value;
		else if (property === "type") obj[1] = value;
		sessionStorage.setItem("ReviewLeaveApplication", JSON.stringify(obj));
	};
	const rowEvents = {
		onClick: (e, row) => {
			history.push({
				pathname: `${Routes.ReviewLeaveApplication}/${row.id}`,
				state: {
					itemStatus: row.itemStatus,
					selectedEmp: selectedSupEmp,
					isFutureLeave:
						new Date().getDate() ===
							new Date(row.startDate).getDate() ||
						(new Date() > new Date(row.startDate) &&
							new Date() > new Date(row.endDate)),
				},
			});
		},
	};
	function getNonSelectableRows(rows) {
		return rows
			.filter((r) => {
				const startDate = new Date(r.startDate);
				const endDate = new Date(r.endDate);

				return !(
					(new Date().getDate() === startDate.getDate() ||
						new Date() > startDate) &&
					new Date() > endDate
				);
			})
			.map((r) => r.id);
	}
	const selectRow = {
		mode: "checkbox",
		clickToSelect: true,
		nonSelectable: getNonSelectableRows(spReviewLeaveData),
		selected: selectedRows.map((row) => row.id), // Assuming your data has an 'id' field
		onSelect: (row, isSelect) => {
			let bulkData = [...bulkSelectedData]; // Use spread operator to avoid mutating state directly
	
			if (isSelect) {
				setDisableRejectSelectedBtn(false);
				setDisableApproveSelectedBtn(false);
				bulkData.push(row);
			} else {
				bulkData = bulkData.filter((item) => item.id !== row.id);
				if (bulkData.length === 0) {
					setDisableRejectSelectedBtn(true);
					setDisableApproveSelectedBtn(true);
				}
			}
			setBulkSelectedData(bulkData);
			setSelectedRows(bulkData); // Update selectedRows state
			setCheckboxSelected(!checkboxSelected);
		},
		onSelectAll: (isSelect, rows, e) => {
			setDisableRejectSelectedBtn(!disableRejectSelectedbtn);
			setDisableApproveSelectedBtn(!disableApproveSelectedbtn);
			setCheckboxSelected(!checkboxSelected);
	
			if (isSelect) {
				const maxSelectedRows = 20;
				const selected = isSelect ? rows.slice(0, maxSelectedRows) : [];
				setSelectedRows(selected);
				setBulkSelectedData(selected);
			} else {
				setBulkSelectedData([]);
				setSelectedRows([]);
				setDisableRejectSelectedBtn(true);
				setDisableApproveSelectedBtn(true);
			}
		},
	};

	const onApproveSelectedbtnClick = () => {
		setDisableRejectSelectedBtn(true);
		setCheckboxSelected(true);
		setApproveSelectedBtnLoad(true);
		let idList = bulkSelectedData.map((item) => item.id);

		//api call
		let body = {
			id: idList,
			approvalStatus: 3, //approve
		};
		axios
			.patch(
				`${ReviewLeaveApplication_API.ApproveRejectBulkLeaveApplications}`,
				body,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setApproveSelectedBtnLoad(false);
					setDisableRejectSelectedBtn(true);
					setDisableApproveSelectedBtn(true);
					AlertPopups.successAlert.fire({
						text: "Application(s) Approved",
					});
					getUnreviewedLeaves();
					setBulkSelectedData([]);
				}
			});
	};
	const onRejectSelectedbtnClick = () => {
		setDisableApproveSelectedBtn(true);
		setCheckboxSelected(true);
		setRejectSelectedBtnLoad(true);
		let idList = bulkSelectedData.map((item) => item.id);
		//api call
		let body = {
			id: idList,
			approvalStatus: 2, //reject
		};
		axios
			.patch(
				`${ReviewLeaveApplication_API.ApproveRejectBulkLeaveApplications}`,
				body,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setRejectSelectedBtnLoad(false);
					setDisableApproveSelectedBtn(true);
					setDisableRejectSelectedBtn(true);
					AlertPopups.successAlert.fire({
						text: "Application(s) Rejected",
					});
					getUnreviewedLeaves();
					setBulkSelectedData([]);
				}
			});
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empRole = userDetails.empRole;
				empDesignation = userDetails.designation;
				return userDetails.designation.toString() === "4" ||
					userDetails.empRole.includes("2") ||
					userDetails.empRole.includes("5") ||
					userDetails.empRole.includes("3") ? (
					<>
						<div className="container-fluid pl-3 pr-3">
							<Header
								title="Review Leave Applications"
								headerBorder="true"
							/>
					
							<FilterationBar
								empRole={empRole}
								supervisorsEmpList={supervisorsEmpList}
								selectedSupEmp={selectedSupEmp}
								onSupEmpChange={(value) => {
									setSelectedSupEmp(value);
									storeFiltersStates(value, "emp");
									updateTableData(
										value.value,
										selectedLeaveType.value
									);
								}}
								leaveTypes={leaveTypes}
								selectedLeaveType={selectedLeaveType}
								onLeaveTypeChange={(value) => {
									setSelectedLeaveType(value);
									storeFiltersStates(value, "type");
									updateTableData(
										selectedSupEmp.value,
										value.value
									);
								}}
								startDate={startDate}
								endDate={endDate}
								endDatePickerDisabled={endDatePickerDisabled}
								onStartDateChange={(startDate) => {
									setStartDate(startDate);
									//if user select start date again after selecting end date(when end date is enabled)
									if (endDate) {
										onDateFilteration(startDate, endDate);
									} else {
										setEndDatePickerDisabled(false);
									}
								}}
								onEndDateChange={(endDate) => {
									setEndDate(endDate);
									onDateFilteration(startDate, endDate);
								}}
							/>
							<BulkRowActionButtonsBar
								checkboxSelected={checkboxSelected}
								onApproveSelectedbtnClick={
									onApproveSelectedbtnClick
								}
								disableApproveSelectedbtn={
									disableApproveSelectedbtn
								}
								onRejectSelectedbtnClick={
									onRejectSelectedbtnClick
								}
								disableRejectSelectedbtn={
									disableRejectSelectedbtn
								}
								rejectSelectedBtnLoad={rejectSelectedBtnLoad}
								approveSelectedBtnLoad={approveSelectedBtnLoad}
							/>
<div className="d-flex justify-content-end">
								<ButtonLoader
									className={ExcelBtnClassName}
									onClick={exportToExcel}
									btnTitle={ExcelBtnTitle}
									showBtnLoading={isLoading}
									disabled={
										!spReviewLeaveData.length || isLoading
									}
								/>
							</div>
							{AllColumns && (
								<PaginationProvider
									pagination={paginationFactory({
										custom: true,
										totalSize: pagerData
											? pagerData.TotalCount
											: 0,
										page: pageNum,
										sizePerPage: numberOfItemsPerPage,
										paginationSize: numberOfItemsPerPage,
									})}
								>
									{({
										paginationProps,
										paginationTableProps,
									}) => {
										return (
											<Table
												inputValue={""}
												keyField={"id"}
												columns={getColumns}
												items={spReviewLeaveData}
												tableStyle={tableStyle}
												paginationProps={
													paginationProps
												}
												paginationTableProps={
													paginationTableProps
												}
												onTablePageChange={
													handleTableChange
												}
												defaultSorted={defaultSorted}
												showFeedback={false}
												tableLoader={isLoading}
												SearchBar={() => {
													return null;
												}}
												pagerData={pagerData}
												receiveData={(PageSize) => {
													receiveData(PageSize);
												}}
												rowEvents={rowEvents}
												striped={true}
												hover={true}
												condensed={true}
												selectRow={selectRow}
											/>
										);
									}}
								</PaginationProvider>
							)}
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
}

export default ReviewLeaveApplication;
